import {WalletPaymentErrorType, WalletPaymentSubmissionFailure, WalletPaymentSubmissionResult, WalletProvider} from '../payment';
import {PaymentModel} from "../payment.model";
import {ConfigurationModel} from '../../configuration/configuration.model';

export abstract class WalletPaymentProcessor {
    public walletProvider: WalletProvider;
    public quickPayAvailable: boolean = false;
    public canSubmit: boolean = true;

    protected resolveSubmission: (value?: WalletPaymentSubmissionResult | PromiseLike<WalletPaymentSubmissionResult>) => void;
    protected rejectSubmission: (reason?: WalletPaymentSubmissionFailure) => void;

    protected constructor(protected paymentModel: PaymentModel, protected configurationModel: ConfigurationModel) {
    }

    public abstract init(): Promise<WalletPaymentProcessor>;

    // noinspection JSUnusedLocalSymbols
    public async submit(amount: number, deferPaymentSheet: boolean = false): Promise<WalletPaymentSubmissionResult> {
        if (!this.canSubmit) {
            throw new WalletPaymentSubmissionFailure(WalletPaymentErrorType.INVALID_STATE);
        }

        if (this.resolveSubmission) {
            this.rejectSubmission && this.rejectSubmission(new WalletPaymentSubmissionFailure(WalletPaymentErrorType.INVALID_STATE));
            await this.init();
        }

        void this.paymentModel.analyticsService.trackWalletPaymentRequestStarted(this.walletProvider);

        return new Promise<WalletPaymentSubmissionResult>((resolve: (value?: WalletPaymentSubmissionResult | PromiseLike<WalletPaymentSubmissionResult>) => void, reject: (reason?: any) => void) => {
            this.resolveSubmission = (val?: WalletPaymentSubmissionResult | PromiseLike<WalletPaymentSubmissionResult>) => {
                this.resolveSubmission = undefined;
                this.rejectSubmission = undefined;
                resolve(val);
            };

            this.rejectSubmission = (reason?: any) => {
                this.resolveSubmission = undefined;
                this.rejectSubmission = undefined;

                // Detect transient activation errors and set a specific error type to trigger retry via a confirmation popup
                if (reason instanceof WalletPaymentSubmissionFailure && reason.providerErrorMessage &&
                    ((this.walletProvider === WalletProvider.APPLE_PAY && reason.providerErrorMessage.includes("The code that shows the Apple Pay payment sheet must be invoked directly by a user activation event")) ||
                        (this.walletProvider === WalletProvider.GOOGLE_PAY && reason.providerErrorMessage.includes("Delegation is not allowed without transient user activation")))) {
                    reason.errorType = WalletPaymentErrorType.TRANSIENT_ACTIVATION;
                }

                reject(reason);
            };

            return deferPaymentSheet ? this.paymentModel.showWalletPaymentSheetDeferred(amount) : this.showPaymentSheet(amount);
        });
    }

    public abstract showPaymentSheet(amount: number): Promise<void>;
}
